import { version } from "../../../package.json";

function AdminFooter() {
  return (
    <footer className="footer pt-0">
      <div className="d-flex align-items-center justify-content-center justify-content-sm-start flex-wrap m-auto">
        <div className="copyright text-center text-lg-left text-muted">
          © {new Date().getFullYear()}
          <a
            className="text-muted ml-1"
            href="https://www.growthcloud.com"
            target="_blank"
            rel="noreferrer"
          >
            GrowthCloud
          </a>
          <span className="pl-3 pr-4">v{version ? version : "DEV"}</span>
        </div>
        <div className="copyright text-center text-lg-left text-muted ml-xs-0 ml-sm-4">
          <a
            className="text-muted mr-3"
            href="/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy
          </a>
          <a
            className="text-muted mr-3"
            href="/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms
          </a>
          <a
            className="text-muted"
            href="https://www.growthcloud.com/support"
            target="_blank"
            rel="noreferrer"
          >
            Support
          </a>
        </div>
      </div>
    </footer>
  );
}

export default AdminFooter;
